import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import GiaychungnhanDKKD from "components/GiaychungnhanDKKD/GiaychungnhanDKKD.js";
export default function BCXedulichhopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo thông tin giấy CNĐKKD",
            tabContent: <GiaychungnhanDKKD />,
          },
        ]}
      />
    </div>
  );
}
